<template>
  <div class="frisbuy-mobile-video-speed-menu" role="menu" aria-label="Playback speed">
    <button
      v-for="option in speedOptions"
      :key="option"
      type="button"
      class="frisbuy-mobile-video-speed-menu__item"
      :class="{ 'frisbuy-mobile-video-speed-menu__item--active': option === modelValue }"
      role="menuitemradio"
      :aria-checked="option === modelValue"
      @click="select(option)"
    >
      <span>{{ formatSpeed(option) }}</span>
      <svg
        v-if="option === modelValue"
        class="frisbuy-mobile-video-speed-menu__check"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M2.5 7.2L5.3 10L11.5 3.8"
          stroke="#FFFFFF"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  modelValue: number;
}>();

const emit = defineEmits<{
  (event: "update:modelValue", value: number): void;
  (event: "close"): void;
}>();

const speedOptions = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

function select(value: number) {
  emit("update:modelValue", value);
  emit("close");
}

function formatSpeed(value: number) {
  if (value === 1) return "Normal";
  return `${value}x`;
}
</script>

<style scoped lang="scss">
.frisbuy-mobile-video-speed-menu {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  min-width: 168px;
  padding: 6px;
  border-radius: 12px;
  background: rgba(43, 43, 43, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
}

.frisbuy-mobile-video-speed-menu__item {
  width: 100%;
  border: 0;
  border-radius: 8px;
  padding: 8px 10px;
  background: transparent;
  color: rgba(255, 255, 255, 0.92);
  font-size: 13px;
  line-height: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.frisbuy-mobile-video-speed-menu__item:active {
  background: rgba(255, 255, 255, 0.16);
}

.frisbuy-mobile-video-speed-menu__item--active {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

.frisbuy-mobile-video-speed-menu__check {
  flex: 0 0 auto;
}
</style>
